<template>
    <div class="template">
        <div class="tempRight">
            <div class="tempTitle">
                <div class="left">系统模板列表</div>
                <div class="right">
                    <el-input placeholder="请输入合同标题" v-model="title" clearable @change="handlSearch"></el-input>
                    <div class="btn" @click="handlSearch">搜索</div>
                </div>
            </div>
            <div class="temp_for">
                <div class="conTemp" v-for="(item,index) in tempData" :key="index" @mouseenter="enters(item)"
                     @mouseleave="leaver(item)">
                    <div class="contract">
                        <img :src="item.url"/>
                        <div class="contractHover" v-show="item.isZhe"></div>
                    </div>
                    <div class="title" :class="item.isZhe ? 'titleHover' : ''">{{item.title}}</div>
                    <div class="con_btn">
                        <div class="btn" @click="handlCheckUse(item,0)">编辑使用</div>
                        <!-- <div class="btn" @click="handlCheckUse(item,1)">查看</div> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                btnActive: false,
                tempData: [],
                title: ''
            }
        },
        mounted() {
            let params = new FormData();
            params.append('token', this.$global.token);
            params.append('type', 0);
            this.getData(params);
        },
        methods: {
            handlSearch() {
                let params = new FormData();
                params.append('token', this.$global.token);
                params.append('type', 0);
                params.append('title', this.title);
                this.getData(params);
            },
            handlCheckUse(item, index) {
                if (index == 0) {
                    this.$router.push({
                        name: 'detalContract',
                        params: {
                            id: item.id,
                            title: item.title,
                            isMy: 0,
                            isLook: 0
                        }
                    })
                } else {
                    this.$router.push({
                        name: 'detalContract',
                        params: {
                            id: item.id,
                            title: item.title,
                            isMy: 0,
                            isLook: 1
                        }
                    })
                }

            },
            enters(item) {
                item.isZhe = true;
            },
            leaver(item) {
                item.isZhe = false;
            },
            getData(params) {
                let _this = this;
                _this.api.getTemplateList(params).then(res => {
                    console.log(res);
                    for (let i = 0; i < res.data.length; i++) {
                        res.data[i].isZhe = false;
                        res.data[i].url = require('../../../../static/img/contar-1.png');
                    }
                    _this.tempData = res.data;
                })
            }
        }
    }
</script>

<style scoped lang="less">
    @import '../../../../static/less/xm.less';

    .template {
        width: @a;
        height: auto;

        .tempRight {
            width: @a;
            height: auto;
            padding-left: 4%;

            .tempTitle {
                width: 1075px;
                height: 40px;
                display: @flex;
                align-items: center;
                justify-content: space-between;

                .left {
                    width: auto;
                    height: 24px;
                    font-family: MicrosoftYaHei-Bold;
                    font-size: 24px;
                    font-weight: normal;
                    font-stretch: normal;
                    letter-spacing: 1px;
                    color: #333333;
                }

                .right {
                    width: 370px;
                    height: 40px;
                    display: @flex;
                    justify-content: flex-end;

                    .btn {
                        width: 80px;
                        height: 40px;
                        background-color: #f5f5f5;
                        border: solid 1px #aaaaaa;
                        letter-spacing: 1px;
                        color: #333333;
                        font-size: 16px;
                        line-height: 40px;
                        text-align: center;
                        cursor: pointer;
                    }
                }
            }

            .temp_for {
                width: 1100px;
                height: auto;

                // overflow: hidden;
                .conTemp:first-child {
                    margin-left: 0;
                }

                .conTemp:nth-child(4n + 1) {
                    margin-left: 0;
                }

                .conTemp {
                    width: 245px;
                    height: 420px;
                    display: inline-block;
                    position: relative;
                    margin: 31px 0 0 31px;
                    padding: 0 3px;

                    .contractHover {
                        width: 245px;
                        height: 340px;
                        position: absolute;
                        top: 0;
                        left: 3.5px;
                        background-image: linear-gradient(270deg,
                        #1e6eee 0%,
                        #109ee7 50%,
                        #01cee0 100%),
                        linear-gradient(#ffffff,
                        #ffffff);
                        background-blend-mode: normal,
                        normal;
                        opacity: 0.4;
                    }

                    .contract {
                        width: 245px;
                        height: 340px;
                        background-color: #ffffff;
                        border: solid 1px #aaaaaa;

                        img {
                            width: @a;
                            height: @a;
                            object-fit: cover;
                        }
                    }

                    .titleHover {
                        background-image: linear-gradient(270deg,
                        #1e6eee 0%,
                        #109ee7 50%,
                        #01cee0 100%),
                        linear-gradient(#f5f5f5,
                        #f5f5f5);
                        background-blend-mode: normal,
                        normal;
                        color: #fff !important;
                    }

                    .title {
                        width: 245px;
                        height: 46px;
                        background-color: #f5f5f5;
                        border: solid 1px #aaaaaa;
                        border-top: 0;
                        text-align: center;
                        line-height: 46px;
                        letter-spacing: 1px;
                        color: #333333;
                        font-size: 18px;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                    }

                    .con_btn {
                        width: 245px;
                        height: 30px;
                        margin-top: 5px;

                        .btn:active {
                            background-image: linear-gradient(270deg,
                            #1e6eee 0%,
                            #109ee7 50%,
                            #01cee0 100%),
                            linear-gradient(#000000,
                            #000000);
                            background-blend-mode: normal,
                            normal;
                            color: #fff;
                        }

                        .btn {
                            width: 245px;
                            height: 30px;
                            text-align: center;
                            line-height: 30px;
                            background-color: #f2f2f2;
                            border: solid 1px #aaaaaa;
                            letter-spacing: 1px;
                            color: #333333;
                            font-size: 14px;
                            cursor: pointer;
                        }
                    }
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/page/contract/template.vue